
import React from 'react';

interface AnimateVeoIconProps extends React.SVGProps<SVGSVGElement> {}

const AnimateVeoIcon: React.FC<AnimateVeoIconProps> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={1.5} 
    stroke="currentColor" 
    {...props}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z" />
    {/* Optional: Add a subtle "V3" or "Veo" if desired, or keep it simple */}
  </svg>
);

export default AnimateVeoIcon;
